import PropTypes from "prop-types";

export default function WelcomeMeetingTranscriptInterface({ setIsImportFileOpen, setFiles }) {
    return (
        <div className="flex-1 px-6 mt-[150px] gap-[48px] flex flex-col overflow-y-auto h-full items-center">
            <div className="flex gap-[10px] flex-col items-center max-w-2xl 2xl:max-w-3xl ">
                <h1 className="text-center font-hel font-medium text-[30px] leading-[42px] xl:text-[42px] xl:leading-[56px]">
                    Turn meetings into structured insights.
                </h1>
                <p className="text-center text-[#F4711F] text-[16px]  font-hel font-medium leading-[26px] ">
                    Automatically transcribe, summarize, and
                    <br />
                    organize every meeting into clear, actionable records.
                </p>
                <div className="flex flex-row gap-[10px] items-center justify-center">
                    <button
                        onClick={() => {
                            setFiles([])
                            setIsImportFileOpen(true)
                        }}
                        className="text-[16px] bg-[#1B5C29] text-white leading-[24px] font-medium font-inter py-[10px] px-[25px] rounded-[8px]"
                    >
                        Upload Files
                    </button>

                </div>
            </div>
        </div>
    );
}

WelcomeMeetingTranscriptInterface.propTypes = {
    setIsImportFileOpen: PropTypes.func.isRequired,
};
